<template>
  <form :action="route" method="POST" autocomplete="off" ref="form">
    <slot></slot>
    <div class="row">
      <div class="col-md-6 offset-md-5">
        <button
          class="btn btn-black form-submit m-0"
          type="submit"
          :disabled="this.buttonDisabled"
        >
          {{ button }}
        </button>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    route: String,
    initialButton: String,
    uploadingText: String,
  },
  data: function () {
    return {
      buttonDisabled: false,
      button: this.initialButton,
    };
  },
  methods: {
    isDisabledSubmitButton: function (value = false) {
      if (value != false) {
        this.button = this.uploadingText;
      } else {
        this.button = this.initialButton;
      }
      this.buttonDisabled = value;
    },
  },
};
</script>
